/**
 * Created by 1 on 2017/8/25.
 */
'use strict';
define([
    './ScreenShotComponent',
    './VisualComponent',
    './AnimateComponent',
    './SelectionComponent',
    './MeasureComponent',
    './tailed/TailedLabelComponent',
    './BufferDrawComponent'
], function(
    ScreenShotComponent,
    VisualComponent,
    AnimateComponent,
    SelectionComponent,
    MeasureComponent,
    TailedLabelComponent,
    BufferDrawComponent
) {
    /**
     * @deprecated
     * @ignore
     * @namespace
     * @memberOf G
     * @alias G.components
     * @description 组件包
     */
    let components = {};

    //截屏组件
    components.ScreenShotComponent = ScreenShotComponent;
    //可视化组件
    // components.VisualComponent = VisualComponent;
    //动画组件
    components.SelectionComponent = SelectionComponent;
    //框选元素组件
    components.AnimateComponent = AnimateComponent;
    //测量组件
    components.MeasureComponent = MeasureComponent;
    //引线标注
    components.TailedLabelComponent = TailedLabelComponent;
    //缓冲区查询组件
    components.BufferDrawComponent = BufferDrawComponent;
    return components;
});